module.exports = __webpack_public_path__ + "static/media/frameshop_5.c17baaf6.jpg";